import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { GoldIcon, SilverIcon, PlatinumIcon } from '../icons/MetalIcons';

const OnboardingModal = ({ show, onHide, onSelectPreset, onCustomize }) => {
  const metalPrices = useSelector(state => state.metalPrices.prices);

  // Calculate estimated months to reach target
  const calculateMonths = (preset) => {
    if (!metalPrices || !metalPrices[preset.metal_type]) return null;

    const metalData = metalPrices[preset.metal_type];
    let pricePerUnit;

    if (preset.weight_type === 'oz') {
      pricePerUnit = metalData.price_per_ounce;
    } else if (preset.weight_type === 'g') {
      pricePerUnit = metalData.price_per_gram;
    }

    if (!pricePerUnit) return null;

    // Add 25% markup
    const totalCost = preset.target_weight * pricePerUnit * 1.25;

    // bi-weekly = ~2 payments per month
    const paymentsPerMonth = 2;
    const monthsNeeded = Math.ceil(totalCost / (preset.amount_per_period * paymentsPerMonth));

    return monthsNeeded;
  };

  const presets = [
    {
      id: 'gold',
      metal_type: 'gold',
      target_weight: 1,
      weight_type: 'g',
      period: 'bi-weekly',
      amount_per_period: 25,
      title: 'Gold',
      subtitle: '1 Gram',
      description: '$25 bi-weekly',
      icon: <GoldIcon size={48} />
    },
    {
      id: 'silver',
      metal_type: 'silver',
      target_weight: 1,
      weight_type: 'oz',
      period: 'bi-weekly',
      amount_per_period: 25,
      title: 'Silver',
      subtitle: '1 Troy Ounce',
      description: '$25 bi-weekly',
      icon: <SilverIcon size={48} />
    },
    {
      id: 'platinum',
      metal_type: 'platinum',
      target_weight: 5,
      weight_type: 'g',
      period: 'bi-weekly',
      amount_per_period: 50,
      title: 'Platinum',
      subtitle: '5 Grams',
      description: '$50 bi-weekly',
      icon: <PlatinumIcon size={48} />
    }
  ];

  const handlePresetSelect = (preset) => {
    onSelectPreset({
      metal_type: preset.metal_type,
      target_weight: preset.target_weight,
      weight_type: preset.weight_type,
      period: preset.period,
      amount_per_period: preset.amount_per_period
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1.25rem' }}>
          Create New Goal
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="bg-gradient-to-br from-gray-50 to-gray-200 py-6 px-6">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-3">Welcome to Auric!</h2>
              <p className="text-gray-600 text-lg">
                Let's set up your first goal and get you on the path to precious metal ownership.
              </p>
            </div>

            {/* Preset Options */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              {presets.map((preset) => (
                <div
                  key={preset.id}
                  onClick={() => handlePresetSelect(preset)}
                  className="bg-white rounded-2xl p-8 cursor-pointer transition-all duration-300 ease-in-out border-2 border-gray-200 shadow-md hover:border-blue-500 hover:shadow-xl hover:transform hover:-translate-y-1"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 mb-3 flex items-center justify-center opacity-80">
                      {preset.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-1">{preset.title}</h3>
                    <p className="text-lg font-semibold text-gray-700 mb-1">{preset.subtitle}</p>
                    <p className="text-sm text-gray-500 mb-2">{preset.description}</p>
                    {calculateMonths(preset) && (
                      <p className="text-xs text-green-600 font-medium">
                        Acquire your {preset.title} in ~{calculateMonths(preset)} month{calculateMonths(preset) > 1 ? 's' : ''}!
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Customize Button */}
            <div className="text-center mb-8">
              <button
                onClick={onCustomize}
                className="bg-white text-gray-700 px-8 py-3 rounded-full font-bold border-2 border-gray-300 hover:border-black hover:text-black transition-colors"
              >
                Customize my first goal
              </button>
            </div>

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OnboardingModal;
